module.exports = __webpack_public_path__ + "bi.svg?5baaa143add7879a25b24d07038bd796";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/bi.svg
// module id = 757
// module chunks = 27